import React from 'react';

/**
 * Reusable component for displaying section details with consistent styling.
 * Takes an array of field objects and renders them uniformly.
 */
const SectionDetails = ({ fields = [], children }) => {
  return (
    <div isolated className="template-view-container application-card section-details">
      {fields.map((field, index) => (
        <div 
          key={index} 
          className={`${field.required ? 'required ' : ''}field field-section`}
        >
          <label>{field.label}</label>
          <div className="field-value">{field.value}</div>
        </div>
      ))}
      {children}
    </div>
  );
};

export default SectionDetails;
